import React from "react";
import ChangeEmailConfirmation from "../../components/changeEmailConfirmation/ChangeEmailConfirmation";

const ChangeEmailConfirmationScreen = () => {
  return (
    <>
      <ChangeEmailConfirmation />
    </>
  );
};

export default ChangeEmailConfirmationScreen;
